module.exports = __webpack_public_path__ + "static/media/UK.3945f6b9.png";